import personFileTemplate from './assets/templates/person-file-template.xlsx';
import hierarchyFileTemplate from './assets/templates/hierarchy-file-template.xlsx';
import groupFileLoadTemplate from './assets/templates/Group_File_Load_Template.xlsx';

export const PERSON_FILE_TYPE = {
    value: 'person',
    text: 'Person Template',
    template: personFileTemplate
};

export const HIERARCHY_FILE_TYPE = {
    value: 'hierarchy',
    text: 'Hierarchy Template',
    template: hierarchyFileTemplate
};

export const GROUP_FILE_TYPE = [ {
    value: 'fixed-group',
    text: 'Create or Update Fixed Groups',
    template: groupFileLoadTemplate
} ];

export const FILE_TYPES = [ 
    {
        value: 'person',
        text: 'Create or Update Persons',
        template: personFileTemplate
    }, {
        value: 'hierarchy',
        text: 'Create or Update Hierarchy',
        template: hierarchyFileTemplate
    }, {
        value: 'group',
        text: 'Group_File_Load_Template',
        template: groupFileLoadTemplate
    }
];

export const EMPLOYMENT_ATTRIBUTES = {
    EMPLOYER: 'employer',
    JOB_TITLE: 'jobTitle',
    DEPARTMENT: 'department',
    HIRE_DATE: 'hireDate',
    TERMINATION_DATE: 'terminationDate',
    LOCATION: 'location',
    STATUS: 'status'
    // SUSPENSION: 'suspension'
};

export const LABELS = {
    PHONE: [ 'business', 'personal', 'cell', 'other' ],
    EMAIL: [ 'business', 'personal', 'other' ],
    ADDRESS: [ 'business', 'home', 'shipping', 'other' ],
    RECOVERY_METHOD: [ 'email' ]
};

export const MAX_GENERAL_SEARCH_RESULTS = 1000;

export const HIERARCHY_NODE_ROLE_TYPES = [
    'owner',
    'manager',
    'member'
];

export const STATUS_TYPES = [
    'active',
    'inactive'
];
export const NEW_GROUP = 'new';
export const EXISTING_GROUP = 'existing';

export const HIERARCHY_NODE_TYPE = 'hierarchyNodeType';
export const GOLD_COMPANY = '00000000-0000-0000-0000-000000000000';